import barSimpleBarChart from "assets/images/chart-images/simple-chart.png";
import table from "assets/images/chart-images/table.png";
import barHorizontalBarChart from "assets/images/chart-images/horizontal-bar-chart.png";
import lineLineChart from "assets/images/chart-images/line-chart.png";


const timePeriodList = [
        { id: "%RIdTP-BV01p", name: "simple-bar", chartImage: barSimpleBarChart, disabled: false },
        { id: "%RIdTP-BH01p", name: "horizontal-bar", chartImage: barHorizontalBarChart, disabled: false },
        { id: "%RIdTP-L01p", name: "line", chartImage: lineLineChart, disabled: false },
        { id: "%RIdTP-T01p", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "%RIdTP-T02p", name: "table", chartImage: table, v2: "Row", disabled: false },
];

export default timePeriodList;

